import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 19px 20px 24px;
  border-bottom: 1px solid #D8E4EB;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 5;
  background: #FFFFFF;
`;

const Roobee = styled.img`
  margin-right: 10px;
`;
const Dao = styled.img``;
const Button = styled.button``;
const Menu = styled.img``;
const Logos = styled.div``;

export default {
  Wrapper,
  Roobee,
  Button,
  Dao,
  Menu,
  Logos,
}
